module.exports = __webpack_public_path__ + "img/WRZS_phone.937ad52f.svg";